import { useNavigate } from 'react-router-dom';

import { navigateTo } from './handlers/navigateTo';
import { useRefetchAccountAndPlan } from './handlers/userPurchasedAiAddon';
import { getAllowedIframeDomains } from './utils/getAllowedIframeDomains';

import { useCustomEvent } from '@/hooks/useCustomEvent';
import { useIframeMessage } from '@/hooks/useIframeMessage';

/**
 * se extiende agregando nuevos `useCustomEvent` o useIframeEvents, cada hook
 * es responsable de escuchar un evento personalizado o mensaje, ejecutar
 * la acción en respuesta a ese evento y limpiar el listener
 * */
export const EventManager = () => {
  const navigate = useNavigate();

  const { refetchAccountAndPlan } = useRefetchAccountAndPlan();

  // TODO: invildar la query de los websites desde un MFE
  // useCustomEvent('[shell] refetch-websites', refreshWebsites as () => void);
  useCustomEvent('[shell] navigateTo', (e) => navigateTo(navigate, e));

  useCustomEvent('user-purchased-ai-addon', () => {
    refetchAccountAndPlan().catch(console.error);
  });

  useIframeMessage(
    'user-purchased-ai-addon',
    () => {
      refetchAccountAndPlan().catch(console.error);
    },
    getAllowedIframeDomains()
  );

  useIframeMessage(
    '[shell] navigateTo',
    (e) => navigateTo(navigate, e),
    getAllowedIframeDomains()
  );

  return <></>;
};
